import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-narrow-sidebar-profile',
  imports: [],
  templateUrl: './narrow-sidebar-profile.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NarrowSidebarProfileComponent {}
